module.exports = __webpack_public_path__ + "static/media/body-male.35af348f.svg";